import Dispatcher from './dispatcher'
import debounce from './debounce'

export default class Breakpoints {
    constructor (breakpoints = { xs: 575, sm: 767, md: 995, lg: 1366, xl: 1920, xxl: 2560 }) {
        const names = Object.keys(breakpoints)
        if (names.length === 0) {
            throw new Error('You should configure breakpoints')
        }
        this._events = new Dispatcher()
        Object.assign(this, breakpoints)
        this._sorted = names
            .map(name => ({
                name,
                value: this[name],
                ['is' + name.toUpperCase()]: true
            }))
            .sort((a, b) => a.value - b.value)

        let lastBreakpoint = this.current
        let lastLandscape = this.landscape

        window.addEventListener('resize', debounce(() => {
            const landscape = this.landscape
            const current = this.current
            const orientationChange = lastLandscape !== landscape
            if (current.value !== lastBreakpoint.value || orientationChange) {
                this._events.fire('change', {
                    last: lastBreakpoint,
                    current,
                    landscape,
                    portrait: !landscape
                })
                lastBreakpoint = current
            }
            if (orientationChange) {
                lastLandscape = landscape
                this._events.fire('orientation', {
                    landscape,
                    portrait: !landscape
                })
            }
        }, 200))
    }

    on (event, handler, immediate = false) {
        this._events.on(event, handler)
        if (immediate) {
            const current = this.current
            handler({
                last: current,
                current,
                landscape: this.landscape,
                portrait: !this.landscape
            })
        }
    }

    off (event) {
        this._events.off(event)
    }

    get current () {
        const viewportWidth = this.viewportSize.width
        const breakpoints = this._sorted
        let lastBreakPoint
        for (let i = 0; i < breakpoints.length; i++) {
            const breakpoint = breakpoints[i]
            if (viewportWidth <= breakpoint.value && (i === 0 || viewportWidth > lastBreakPoint.value)) {
                return breakpoint
            } else {
                lastBreakPoint = breakpoint
            }
        }
    }

    get viewportSize () {
        const documentElement = document.documentElement
        return {
            width: documentElement.clientWidth,
            height: documentElement.clientHeight
        }
    }

    get landscape () {
        return this.viewportSize.width > this.viewportSize.height
    }

    get portrait () {
        return !this.landscape
    }

    isBetween (smallBreakpoint, largeBreakpoint) {
        return this.viewportSize.width >= this[smallBreakpoint] && this.viewportSize.width <= this[largeBreakpoint]
    }

    isLessThan (breakpoint) {
        return this.viewportSize.width < this[breakpoint]
    }

    isGreaterThan (breakpoint) {
        return this.viewportSize.width > this[breakpoint]
    }

    isLessThanEqualTo (breakpoint) {
        return this.viewportSize.width <= this[breakpoint]
    }

    isGreaterThanEqualTo (breakpoint) {
        return this.viewportSize.width >= this[breakpoint]
    }
}
